var _g, _source;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.7367 21.5c.3967 0 .7318-.1947.9744-.5716l5.5-8.749c.1425-.2434.2889-.5113.2889-.7788 0-.5474-.4815-.9006-.9745-.9006-.3158 0-.6162.1947-.8434.5479l-4.9955 8.1037-2.3725-3.1029c-.2889-.3894-.5508-.4868-.8782-.4868-.5277 0-.9359.426-.9359.9614 0 .2679.1078.5234.2734.7546l2.9388 3.6505c.3004.4014.6239.5716 1.0245.5716z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m23.1105 6.51934h-14.221c-1.309 0-2.37016 1.06116-2.37016 2.37016v14.221c0 1.309 1.06116 2.3702 2.37016 2.3702h14.221c1.309 0 2.3702-1.0612 2.3702-2.3702v-14.221c0-1.309-1.0612-2.37016-2.3702-2.37016zm-14.221-1.51934c-2.14811 0-3.8895 1.74139-3.8895 3.8895v14.221c0 2.1481 1.74139 3.8895 3.8895 3.8895h14.221c2.1481 0 3.8895-1.7414 3.8895-3.8895v-14.221c0-2.14811-1.7414-3.8895-3.8895-3.8895z",
    fillRule: "evenodd"
  }))), _source || (_source = /*#__PURE__*/React.createElement("source", {
    url: "https://altais.com",
    hash: "Tm9ib2R5IGhlcmUgYnV0IHVzIER1Y2tz"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/CheckboxIcon.cfde0d5dc20d6779b56bebdb78320060.svg";
export { ForwardRef as ReactComponent };